// extracted by mini-css-extract-plugin
export default {"header":"sticky-header-module--header--1bb98"};